<mtg-statistic-table
  *ngIf="players.length > 0"
  title="Игроки"
  [statisticHeader]="getStatisticHeader()"
  [statistic]="players"
  [pageSize]="pageSize"
  [sport]="sport"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  sort="goals"
  order="desc"
></mtg-statistic-table>
<mtg-statistic-table
  *ngIf="goaltenders.length > 0"
  title="Вратари"
  [statistic]="goaltenders"
  [statisticHeader]="getStatisticHeader(true)"
  [goalie]="true"
  [pageSize]="pageSize"
  [sport]="sport"
  [teamLogoVisible]="teamLogoVisible"
  [identity]="identity"
  sort="savesPercent"
  order="desc"
></mtg-statistic-table>
